package ui.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.TextFieldColors
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.StringResource
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.global_empty
import tools.EFieldColorAsLong
import tools.rememberString


@Composable
fun ColorField(
    field: EFieldColorAsLong,
    label: StringResource,
    colors: TextFieldColors = TextFieldDefaults.colors(),
    shape: Shape = TextFieldDefaults.shape,
    modifier: Modifier = Modifier
) {
    val pickerState = DialogState.remember()

    ColorPicker(pickerState, field, label) {
        field.set(it)
    }

    val labelFun: (@Composable () -> Unit) = {
        Text(label.rememberString())
    }
    val leadingIcon: (@Composable () -> Unit) = {
        Spacer(
            Modifier.size(32.dp)
                .clip(RoundedCornerShape(8))
                .clickable { pickerState.show() }
                .background(Color.White)
                .border(2.dp, Color.White)
                .clip(RoundedCornerShape(8))
                .background(field.state, RoundedCornerShape(8.dp))
        )
    }
    if (label == Res.string.global_empty) {
        TextField(
            value = field.text,
            leadingIcon = leadingIcon,
            isError = field.err,
            modifier = modifier,
            colors = colors,
            shape = shape,
            onValueChange = { field.setText(it) })
    } else {
        TextField(
            value = field.text,
            label = labelFun,
            leadingIcon = leadingIcon,
            isError = field.err,
            modifier = modifier,
            colors = colors,
            shape = shape,
            onValueChange = { field.setText(it) })
    }
}